export default __webpack_public_path__ + "static/media/headPhone.60a3ba50.jpg";